import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { route } from "../../router/route";

import PCContainer from "../../components/atoms/layout/pcContainer";

import useDisplay from "../../hooks/useDisplay";
import LSRgDisplay02 from "../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LectureItemPage from "../../components/organisms/lecture/lectureItemPage";
import Empty from "../../components/molecules/empty";
import OnboardingModal from "../../components/templates/modals/onboardingModal";
import LSBdDisplay03 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay03";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import MainBtn from "../../components/atoms/button/mainBtn";
import LectureApi from "../../api/lecture.api";
import { errorHandler } from "../../util/errorHandler";
import { fileUrl } from "../../api/api";
import { formatNumberWithCommas } from "../../util/formatNumber";
import ConfirmModal from "../../components/templates/modals/confirmModal";

const LectureOnboardingComplete = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const navigate = useNavigate();

  const [recommendList, setRecommendList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isOnboardingModal, setIsOnboardingModal] = useState(false);
  const [isConfrimModal, setIsConfrimModal] = useState(false);

  useEffect(() => {
    recommendListFunc();
  }, []);

  const recommendListFunc = async () => {
    try {
      const data = {
        page: 1,
        size: 9,
      };

      const response = await LectureApi.onBoardinglectureList(data);
      const content = response.data.data?.content ?? [];

      const slicedArray = content.slice(0, 3); // 앞에서 3개 요소를 자름
      setRecommendList(slicedArray);

      const slicedArray02 = content.slice(3); // 나머지
      setProductList(slicedArray02);
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <LectureOnboardingCompleteSection>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            width: "100%",
            position: "relative",
            objectFit: "contain",
          }}
        >
          <img
            onClick={() => {
              setIsConfrimModal(true);
            }}
            style={{
              cursor: "pointer",
              width: "100%",
              height: "100%",
            }}
            src={
              isSmall
                ? "/assets/images/onboarding_re_m.png"
                : "/assets/images/onboarding_re.png"
            }
            alt="onboarding_re"
          />
        </div>

        <PCContainer
          style={{
            flexDirection: "column",
            padding: isMobile
              ? "40px 20px 80px 20px"
              : isTablet
              ? "40px 60px 80px 60px"
              : "80px 0px 150px 0px",
            width: "100%",
          }}
        >
          <LSRgDisplay02
            style={{
              color: "#000000",
              fontSize: isMobile ? 16 : 24,
              lineHeight: isMobile ? "22.4px" : "33.6px",
            }}
          >
            📌 {sessionStorage.getItem("name") || "회원"} 님만을 위한 맞춤 강의
            추천!
          </LSRgDisplay02>

          {recommendList.length > 0 ? (
            recommendList.map((item, index) => {
              return (
                <div
                  key={item.id}
                  style={{
                    marginTop: isSmall ? (index === 0 ? 30 : 40) : 30,
                    position: "relative",
                    display: "flex",
                    flexDirection: isSmall ? "column" : "row",
                  }}
                >
                  <img
                    style={{
                      width: isMobile ? 70 : 120,
                      height: isMobile ? 70 : 120,
                      zIndex: 3,
                      position: "absolute",
                      top: -2,
                      left: -2,
                    }}
                    src={"/assets/images/number.png"}
                    alt="number"
                  />

                  <LSBdDisplay03
                    style={{
                      color: "#ffffff",
                      position: "absolute",
                      top: isMobile ? 7 : 14,
                      left: isMobile ? 7 : 14,
                      fontSize: isMobile ? 20 : 32,
                      lineHeight: isMobile ? "28px" : "44.8px",
                      zIndex: 4,
                    }}
                  >
                    0{index + 1}
                  </LSBdDisplay03>

                  <ImageWrapper
                    isSmall={isSmall}
                    isMobile={isMobile}
                    isTablet={isTablet}
                  >
                    <HoverableImage
                      isSmall={isSmall}
                      src={
                        item?.thumbnailServerFileName
                          ? `${fileUrl}/${item.thumbnailServerFileName}`
                          : ""
                      }
                      alt="video_temp01"
                    />
                  </ImageWrapper>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      marginTop: isSmall ? 16 : 0,
                    }}
                  >
                    <LSBdDisplay03
                      style={{
                        marginBottom: isMobile ? 4 : 8,
                        color: "#000000",
                        fontSize: isMobile ? 16 : 32,
                        lineHeight: isMobile ? "22.4px" : "44.8px",
                      }}
                    >
                      {item.title}
                    </LSBdDisplay03>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: isMobile ? 4 : 0,
                      }}
                    >
                      {/* <LSRgH1HeadLine
                        style={{
                          color: "#6F7480",
                          fontSize: isMobile ? 12 : 16,
                          lineHeight: isMobile ? "14.4px" : "22.4px",
                        }}
                      >
                        {item.lectureCategory.title}
                      </LSRgH1HeadLine>
                      <div
                        style={{
                          height: isMobile ? 12 : 16,
                          width: 1,
                          marginLeft: isMobile ? 14 : 8,
                          marginRight: isMobile ? 14 : 8,
                          background: "#6F7480",
                        }}
                      /> */}
                      <img
                        style={{
                          width: 16,
                          height: 16,
                          marginRight: 4,
                        }}
                        src="/assets/icons/star_3d.png"
                        alt="star_3d"
                      />
                      <LSRgH1HeadLine
                        style={{
                          color: "#6F7480",
                          fontSize: isMobile ? 12 : 16,
                          lineHeight: isMobile ? "14.4px" : "22.4px",
                        }}
                      >
                        {item.reviewScore ? item.reviewScore?.toFixed(1) : 0}
                      </LSRgH1HeadLine>
                      <div
                        style={{
                          height: isMobile ? 12 : 16,
                          width: 1,
                          marginLeft: isMobile ? 14 : 8,
                          marginRight: isMobile ? 14 : 8,
                          background: "#6F7480",
                        }}
                      />
                      <LSRgH1HeadLine
                        style={{
                          color: "#6F7480",
                          fontSize: isMobile ? 12 : 16,
                          lineHeight: isMobile ? "14.4px" : "22.4px",
                        }}
                      >
                        {formatNumberWithCommas(item.reviewCount)}개의 수강후기
                      </LSRgH1HeadLine>
                    </div>
                    {isMobile ? null : (
                      <div
                        style={{
                          width: "100%",
                          height: 1,
                          background: "#DBDDE0",
                          margin: "40px 0px 20px 0px",
                        }}
                      />
                    )}

                    <div
                      style={{
                        display: "flex",
                        flexDirection: isMobile ? "row" : "column",
                      }}
                    >
                      <TopTextContain
                        style={{
                          marginBottom: isMobile ? 0 : 8,
                        }}
                      >
                        <TopRightText
                          style={{
                            width: isMobile ? "auto" : 55,
                            fontSize: isMobile ? 12 : 16,
                            lineHeight: isMobile ? "14.4px" : "22.4px",
                            marginRight: isMobile ? 12 : 18,
                          }}
                        >
                          수강기간
                        </TopRightText>
                        <TopLeftText
                          style={{
                            fontSize: isMobile ? 12 : 16,
                            lineHeight: isMobile ? "14.4px" : "22.4px",
                          }}
                        >
                          {item?.limitFlag
                            ? "무제한"
                            : `${formatNumberWithCommas(item?.period)}일`}
                        </TopLeftText>
                      </TopTextContain>
                      {isMobile ? (
                        <div
                          style={{
                            height: 12,
                            width: 1,
                            marginLeft: 8,
                            marginRight: 8,
                            background: "#6F7480",
                          }}
                        />
                      ) : null}
                      <TopTextContain
                        style={{
                          marginBottom: isMobile ? 0 : 8,
                        }}
                      >
                        <TopRightText
                          style={{
                            width: isMobile ? "auto" : 55,
                            fontSize: isMobile ? 12 : 16,
                            lineHeight: isMobile ? "14.4px" : "22.4px",
                            marginRight: isMobile ? 12 : 18,
                          }}
                        >
                          커리큘럼
                        </TopRightText>
                        <TopLeftText
                          style={{
                            fontSize: isMobile ? 12 : 16,
                            lineHeight: isMobile ? "14.4px" : "22.4px",
                          }}
                        >
                          총 {formatNumberWithCommas(item?.curriculumCount)}강
                        </TopLeftText>
                      </TopTextContain>
                      {isMobile ? (
                        <div
                          style={{
                            height: 12,
                            width: 1,
                            marginLeft: 8,
                            marginRight: 8,
                            background: "#6F7480",
                          }}
                        />
                      ) : null}
                      <TopTextContain
                        style={{
                          marginBottom: 0,
                        }}
                      >
                        <TopRightText
                          style={{
                            width: isMobile ? "auto" : 55,
                            fontSize: isMobile ? 12 : 16,
                            lineHeight: isMobile ? "14.4px" : "22.4px",
                            marginRight: isMobile ? 12 : 18,
                          }}
                        >
                          강사명
                        </TopRightText>
                        <TopLeftText
                          style={{
                            fontSize: isMobile ? 12 : 16,
                            lineHeight: isMobile ? "14.4px" : "22.4px",
                          }}
                        >
                          {item?.instructorName}
                        </TopLeftText>
                      </TopTextContain>
                    </div>

                    <div
                      style={{
                        flex: 1,
                      }}
                    />

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        marginTop: isSmall ? 16 : 0,
                      }}
                    >
                      <MainBtn
                        onClick={() => {
                          navigate(`${route.lecture_detail}/${item.id}`);
                        }}
                        style={{
                          height: isMobile ? 46 : 60,
                          width: isSmall ? "100%" : 277,
                        }}
                      >
                        <LSRgDisplay02
                          style={{
                            color: "#FFFFFF",
                            textAlign: "center",
                            fontSize: isMobile ? 16 : 24,
                            lineHeight: isMobile ? "22.4px" : "33.6px",
                          }}
                        >
                          자세히 보기
                        </LSRgDisplay02>
                      </MainBtn>
                    </div>
                  </div>
                </div>
              );
            })
          ) : isLoading ? null : (
            <Empty title={"등록된 강의가 없습니다."} />
          )}

          <LSRgDisplay02
            style={{
              color: "#000000",
              marginBottom: isMobile ? 16 : isTablet ? 30 : 30,
              fontSize: isMobile ? 16 : 24,
              lineHeight: isMobile ? "22.4px" : "33.6px",
              marginTop: isMobile ? 80 : 150,
            }}
          >
            🙌 이런 강의도 추천해요
          </LSRgDisplay02>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: isMobile ? "19px 0px" : "30px",
                flexDirection: "row",
                justifyContent: isSmall ? "space-between" : "flex-start",
                flexWrap: "wrap",
                width: "100%",
              }}
            >
              {productList.length > 0 ? (
                productList.map((item) => {
                  return <LectureItemPage key={item.id} data={item} />;
                })
              ) : isLoading ? null : (
                <Empty title={"등록된 강의가 없습니다."} />
              )}
            </div>
          </div>
        </PCContainer>
      </LectureOnboardingCompleteSection>

      {isOnboardingModal ? (
        <OnboardingModal setVisiable={setIsOnboardingModal} isScroll={false} />
      ) : null}

      {isConfrimModal ? (
        <ConfirmModal
          title={"이미 진행한 온보딩이 있어요!"}
          content={
            "새로운 온보딩을 진행할 경우,\n이전 온보딩에서 추천받은 영상은 저장되지 않습니다."
          }
          yText={"다시하기"}
          isNegative={true}
          onClick={() => {
            setIsConfrimModal(false);
          }}
          onYClick={() => {
            setIsConfrimModal(false);
            setIsOnboardingModal(true);
          }}
          setVisiable={setIsConfrimModal}
          isScroll={false}
        />
      ) : null}
    </>
  );
};

export default LectureOnboardingComplete;

const LectureOnboardingCompleteSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const TopTextContain = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
`;

const TopRightText = styled(LSBdH1HeadLine)`
  width: 55px;
  margin-right: 18px;
  color: #898e99;
`;

const TopLeftText = styled(LSRgH1HeadLine)`
  color: #000000;
`;

const ImageWrapper = styled.div`
  overflow: hidden;
  border-radius: ${({ isSmall }) => (isSmall ? "20px" : "30px")};
  min-width: ${({ isSmall }) => (isSmall ? "100%" : "585px")};
  max-width: ${({ isSmall }) => (isSmall ? "100%" : "585px")};
  height: ${({ isMobile, isTablet }) =>
    isMobile ? "214px" : isTablet ? "auto" : "374px"};
  margin-right: ${({ isSmall }) => (isSmall ? "0" : "30px")};
`;

const HoverableImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: ${({ isSmall }) => (isSmall ? "20px" : "30px")};
  transition: transform 0.3s ease, filter 0.3s ease;

  &:hover {
    transform: scale(1.04); /* 이미지 확대 */
    transition: transform 0.3s ease-in-out; /* 부드러운 애니메이션 */
  }
`;
